import React from 'react';
import { BookOpenIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, MapPinIcon, ShieldCheckIcon, SparklesIcon, StarIcon, UsersIcon } from 'lucide-react';
import { mockupUrl } from '../data/content';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-174" data-mp="4mru70n4vzl8">
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-175" data-mp="12a0l5b5wm0um">
        <p className="mb-5 inline-flex rounded-full border border-gold/30 bg-gold/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-gold md:mb-7" data-id="element-176" data-mp="1274orr9pfk8a">
          🎀 Compra Digital Ya™
        </p>
        <h1 className="mx-auto max-w-4xl text-[1.9rem] font-black leading-[1.05] tracking-tight text-white md:text-6xl" data-id="element-177" data-mp="nc858hwg3afw">
          Todo tu año de rítmica.
          <br data-id="element-178" data-mp="3d33ecx6girk8" />
          <span className="text-gold" data-id="element-179" data-mp="3czfkfwx3o34z">Listo. Desde hoy.</span>
        </h1>
        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver las opciones de compra de Gimnasia Rítmica PRO" data-id="element-180" data-mp="381nwfdzkt162">
          <img className="w-full max-w-[720px] object-contain drop-shadow-[0_30px_60px_rgba(245,199,75,.18)] transition-transform duration-200 ease-smooth group-hover:scale-[1.015]" src={mockupUrl} alt="Mega Bundle Gimnasia Rítmica PRO con sus 6 tomos y los 6 bonos incluidos" data-id="element-181" data-mp="3o6u7fbahgtdg" />
        </a>
        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-zinc-200 md:text-xl" data-id="element-182" data-mp="358rfooqjwiby">
          <strong className="text-white" data-id="element-183" data-mp="2qk3m2o09mion">GIMNASIA RÍTMICA PRO.</strong> El sistema N°1 para
          profesores de Gimnasia Rítmica en Argentina. Clases, ejercicios y planificaciones 100%
          listos para usar, de la iniciación al nivel competitivo.
        </p>
        <p className="mt-4 text-sm font-bold uppercase tracking-wide text-gold md:text-base" data-id="element-184" data-mp="2hl9sl6i8e8fb">
          Sin buscar. Sin improvisar. Sin perder domingos.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-zinc-300 md:text-sm" data-id="element-185" data-mp="s332b5sqsatu">
          <span className="flex items-center gap-1.5" data-id="element-186" data-mp="na08cwk1yzd4">
            <FileTextIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-187" data-mp="ibgm0v1jrlk8" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-188" data-mp="de6munocvvj7">
            <ClockIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-189" data-mp="1b0vw9ile1af3" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-190" data-mp="161ay3ae1l63f">
            <MapPinIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-191" data-mp="162m47guympxp" />
            Argentina 2026
          </span>
          <span className="flex items-center gap-1.5" data-id="element-192" data-mp="114kjyslsskkn">
            <SparklesIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-193" data-mp="x0csworvasj9" />
            Los 5 aparatos
          </span>
        </div>
        <div className="mt-7" data-id="element-194" data-mp="3lqui5yd6ip9t">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-195" data-mp="3hqu269afm60n">
            🎀 Quiero mi Gimnasia Rítmica PRO ahora →
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-zinc-400 md:text-sm" data-id="element-196" data-mp="21awf0ddvszij">
          <span className="flex items-center gap-1" data-id="element-197" data-mp="269r2hsmsnc8z">
            <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-198" data-mp="26869i7g4o1d8" />
            Garantía 7 días
          </span>
          <span aria-hidden="true" className="text-zinc-700" data-id="element-199" data-mp="2g0c0bdun8cqu">
            ·
          </span>
          <span className="flex items-center gap-1" data-id="element-200" data-mp="2kynbpt0l6vb6">
            <LockIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-201" data-mp="2kxc9hxmshvm6" />
            Pago seguro
          </span>
          <span aria-hidden="true" className="text-zinc-700" data-id="element-202" data-mp="2oye6e7t8hvkz">
            ·
          </span>
          <span className="flex items-center gap-1" data-id="element-203" data-mp="2txhek14ighx6">
            <CreditCardIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-204" data-mp="un9bbrw7qrh9" />
            Mercado Pago
          </span>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-205" data-mp="zlsuxlnc3r6g">
          <TrustCard icon={<UsersIcon className="h-5 w-5 text-gold" data-id="element-207" data-mp="4dgwkrl5hh6j" />} text="+500 profesoras confían" data-id="element-206" data-mp="4a2tfh4nx3y1" />
          <TrustCard icon={<BookOpenIcon className="h-5 w-5 text-gold" data-id="element-209" data-mp="e9a7y7n4v4mq" />} text="6 Tomos listos" data-id="element-208" data-mp="3vk1i5vsfrww6" />
          <TrustCard icon={<GiftIcon className="h-5 w-5 text-gold" data-id="element-211" data-mp="9aqkg2sw5ks9" />} text="6 Bonos incluidos" data-id="element-210" data-mp="e77ibopw7dij" />
          <TrustCard icon={<StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-213" data-mp="3hpr180mol70o" />} text="4,9/5 · ★★★★★" data-id="element-212" data-mp="98mjntqah1w7" />
        </div>
      </div>
    </section>;
}
function TrustCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center gap-2 rounded-2xl border border-line bg-surface p-3" data-id="element-214" data-mp="3rhn0hf0i736h">
      <span aria-hidden="true" data-id="element-215" data-mp="3mnshyewmwu8z">{icon}</span>
      <span className="text-center text-[11px] font-bold leading-tight text-white md:text-sm" data-id="element-216" data-mp="2yzj5i3lb9iui">
        {text}
      </span>
    </div>;
}